import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class IzvjestajZavrsenihRnService {
  constructor(private _http: HttpClient) {}

  dohvatiIzvjestaje(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dnevni_izvjestaj_planovi', a)
      .pipe(map((res: any) => res));
  }

  dohvatiOdstupanja(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dnevni_izvjestaj_odstupanja', a)
      .pipe(map((res: any) => res));
  }

  dohvatiOTP(a: any) {
    return this._http
      .post(
        AppConfig.ipAddress +
          'dohvacanje_ostalih_troskova_proizvodnje_planskakalkulacija',
        a
      )
      .pipe(map((res: any) => res));
  }

  datotekaPopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_dokument', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPlan(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_jedan_planproizvodnje', a)
      .pipe(map((res: any) => res));
  }
}
